import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/ApiService/api.service';
import { environment } from '../../../environments/environment';
import { generateUuidV4 } from '../../shared/Utils/uuid.util';

@Injectable({
  providedIn: 'root'
})
export class TestimonialService {

  // NAPS testimonials API service
  private readonly baseUrl = `${environment.grievance_base_url}/api/testimonial`;
  private readonly basePath = environment.base_url

  constructor(
    private apiService: ApiService
  ) {}

  /**
   * Public/candidate visibility flags for testimonials-related nav & tabs.
   */
  getVisibility(): Observable<any> {
    return this.apiService.get(`${this.baseUrl}/visibility`);
  }

  /**
   * Site-wide visitor count shown in the footer.
   */
  getVisitorCount(): Observable<any> {
    return this.apiService.get(`${this.basePath}/visitor-count`);
  }

  /**
   * Create Testimonial
   */
  createTestimonial(data: FormData) {
    const headers = new HttpHeaders({
      'Idempotency-Key': generateUuidV4(),
    });

    return this.apiService.post(
      this.baseUrl+'/',
      data,
      { headers }
    );
  }

  /**
   * Get All Testimonials
   */
  getTestimonials(params?: any) {
    return this.apiService.get(
      this.baseUrl+"/by-user",
      params
    );
  }


  getEstablishments() {
    return this.apiService.get(
    `${this.basePath}/testimonials/my-establishments`
    )
  }

  getDashboardStats() {
    return this.apiService.get(
    `${this.baseUrl}/pendency`
    )
  }

  canCreateTestimonial() {
    return this.apiService.get(
      `${this.baseUrl}/can-create`
    )
  }


  /**
   * Get Single Testimonial
   */
  getTestimonialById(id: string) {
    return this.apiService.get(
      `${this.baseUrl}/${id}`
    );
  }

    /**
   * Get Single Testimonial Timeline
   */
  getTestimonialTimelineEvents(id:string) {
    return this.apiService.get(
      `${this.baseUrl}/${id}/logs`
    );
  }

  /**
   * Update Testimonial
   */
  updateTestimonial(id: string, data: FormData) {
    return this.apiService.post(
      `${this.baseUrl}/${id}`,
      data
    );
  }

  /**
   * Delete Testimonial
   */
  cancelTestimonial(id: string) {
    return this.apiService.delete(
      `${this.baseUrl}/${id}`
    );
  }

  /**
   * Change Status (Optional)
   */
  updateStatus(id: string, status: boolean) {
    return this.apiService.patch(
      `${this.baseUrl}/${id}/status`,
      { status }
    );
  }

  getPublishedTestimonials(params?: any) {
    return this.apiService.get(
      `${this.baseUrl}/published`,
      params
    );
  }

  getPublishedTestimonialById(id: string) {
    return this.apiService.get(
      `${this.baseUrl}/published/${id}`
    );
  }
}